import { forwardRef, type LegacyRef } from 'react';
import { useNavigate } from 'react-router-dom';
import assert from 'assert';
import FilteredUsers from './FilteredUsers';
import StateDecorator from '../../../components/utils/state/StateDecorator';
import { isDataState } from '../../../store/data/state';
import { useAppSelector } from '../../../store/hooks';
import ManagementDecorator from '../ManagementDecorator';

function UserList(_: object, ref: LegacyRef<HTMLDivElement>): JSX.Element {
  // Retrieve users data.
  const users = useAppSelector((state) => state.data_slice.externals.users);

  // Retrieve roles.
  const roles = useAppSelector((state) => state.data_slice.externals.roles);

  const navigate = useNavigate();
  const refresh = () => {
    navigate(0);
  };

  return ManagementDecorator(ref, () => {
    return StateDecorator([users, roles], ref, () => {
      assert(isDataState(users));
      assert(isDataState(roles));

      return (
        <FilteredUsers
          users={Object.values(users.data)}
          roles={Object.values(roles.data)}
          refresh={refresh}
        />
      );
    });
  });
}

export default forwardRef(UserList);
